"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseUserStats;
function parseUserStats(stats) {
  return {
    sessionModulesStudied: stats.modulesStudied,
    sessionModulesTested: stats.modulesTested,
    sessionModulesCorrect: stats.modulesCorrect,
    sessionModulesIncorrect: stats.modulesIncorrect,
    sessionModulesGaveUp: stats.modulesGaveUp,
    averageScore: stats.averageScore,
    studyDuration: stats.studyDuration,
    sessionsCompleted: stats.sessionsCompleted
  };
}